<!--
  TableSortHeader Component
  Reusable <th> element with sort toggle.
  Click cycles: asc → desc → neutral (non-active column starts at asc)
-->
<script lang="ts">
  import { createEventDispatcher } from 'svelte';
  import ArrowUpDown from 'lucide-svelte/icons/arrow-up-down';
  import ArrowUp from 'lucide-svelte/icons/arrow-up';
  import ArrowDown from 'lucide-svelte/icons/arrow-down';

  export let label: string;
  export let sortKey: string;
  export let currentSortBy: string | null = null;
  export let currentSortOrder: 'asc' | 'desc' | null = null;
  /** Additional CSS classes for the <th> element */
  export let thClass = '';

  const dispatch = createEventDispatcher<{
    sort: { key: string; order: 'asc' | 'desc' | null };
  }>();

  $: isActive = currentSortBy === sortKey;
  $: activeOrder = isActive ? currentSortOrder : null;

  function handleSortClick() {
    let nextOrder: 'asc' | 'desc' | null;
    if (!isActive || activeOrder === null) {
      nextOrder = 'asc';
    } else if (activeOrder === 'asc') {
      nextOrder = 'desc';
    } else {
      nextOrder = null;
    }
    dispatch('sort', { key: sortKey, order: nextOrder });
  }
</script>

<th
  class="px-4 py-3 text-left text-xs font-semibold uppercase tracking-wider text-text-muted {thClass}"
>
  <button
    type="button"
    class="flex items-center gap-1 hover:text-text transition-colors cursor-pointer bg-transparent border-none p-0 text-xs font-semibold uppercase tracking-wider
      {isActive ? 'text-accent' : 'text-text-muted'}"
    on:click={handleSortClick}
  >
    {label}
    {#if activeOrder === 'asc'}
      <ArrowUp class="w-3.5 h-3.5" strokeWidth={2} />
    {:else if activeOrder === 'desc'}
      <ArrowDown class="w-3.5 h-3.5" strokeWidth={2} />
    {:else}
      <ArrowUpDown class="w-3.5 h-3.5 opacity-40" strokeWidth={1.5} />
    {/if}
  </button>
</th>
